import Toaster from './components/Toast';
import initMediaQuery from './utilities/media-queries';
import initModals, { addModal } from './components/Modals';
import initPopUps, { addPopUp } from './components/PopUps';
import initHeaderDisclosures from './components/Header-Disclosures';
import initScrollMarkers, { addScrollMarkers } from './components/ScrollMarkers';
import initStickyElements from './components/Sticky-Element';
import initTabs, { addTabList } from './components/Tabs';
import initToggleTips, {addToggleTip} from './components/ToggleTips';
import initUserTips, { addUserTip } from './components/UserTips';
import EventBus from './utilities/event-bus';

window.$EventBus = new EventBus;

window.jwc = {
    toggleTips: {
        init: target => initToggleTips(target),
        add: element => addToggleTip(element),
    },
    popUps: {
        init: target => initPopUps(target),
        add: target => addPopUp(target),
    },
    headerDisclosures: {
        init: target => initHeaderDisclosures(target),
    },
    modals: {
        init: target => initModals(target),
        add: (modal, opener, settings) => addModal(modal, opener, settings),
    },
    userTips: {
        init: target => initUserTips(target),
        add: element => addUserTip(element),
    },
    tabs: {
        init: target => initTabs(target),
        add: (element, settings) => addTabList(element, settings),
    },
    scrollMarkers: {
        init: target => initScrollMarkers(target),
        add: (element, settings) => addScrollMarkers(element, settings),
    },
};

window.addEventListener('DOMContentLoaded', () => {
    initModals();
    initPopUps();
    initHeaderDisclosures();
    initScrollMarkers();
    initStickyElements();
    initTabs();
    initToggleTips();
    initUserTips();
    initMediaQuery();
    window.jwc.toaster = new Toaster();
});